import { Button as MaterialButton } from '@mui/material';
import { FC } from 'react';

import Button from '@/components/Button';
import CreditsButton from '@/components/CreditsButton';
import Dialog from '@/components/Dialog';
import MaterialIcon from '@/components/Icon/MaterialIcon';
import { money } from '@/core/money';
import { teal500 } from '@/theme/colors';

import s from './RequestTranscript.module.scss';

interface RequestTranscriptProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  submittingTranscript: boolean;
  transcriptionPrice: { cents: number; currency: string };
  transcriptionPriceUSD?: { cents: number; currency: string } | null;
  isUSD?: boolean;
}

const RequestTranscript: FC<RequestTranscriptProps> = ({
  open,
  onCancel,
  onConfirm,
  transcriptionPrice,
  transcriptionPriceUSD,
  submittingTranscript,
  isUSD,
}) => {
  const priceLabel =
    isUSD && transcriptionPriceUSD
      ? money(transcriptionPriceUSD).formatted()
      : isUSD && transcriptionPrice
        ? money(transcriptionPrice).formatted()
        : undefined;

  return (
    <Dialog open={open} onClose={onCancel}>
      <div className={s.icons}>
        <MaterialIcon icon="speaker_notes" size={40} color={teal500} />
      </div>

      <h4 className={s.title}>Request Call Transcript</h4>

      <p className={s.text}>Typical turnaround time is 24 hours.</p>

      <p className={s.text}>
        Call duration, connection quality, and languages spoken factor into timing.
      </p>

      <div className={s.actions}>
        <MaterialButton onClick={onCancel}>Cancel</MaterialButton>

        {isUSD ? (
          <Button disabled={submittingTranscript} size="medium" onClick={onConfirm}>
            {submittingTranscript
              ? 'Requesting...'
              : priceLabel
                ? `Request (${priceLabel})`
                : 'Request'}
          </Button>
        ) : (
          <CreditsButton
            disabled={submittingTranscript}
            credits={transcriptionPrice && transcriptionPrice.cents}
            // @ts-expect-error TS(2769) FIXME: No overload matches this call.
            onClick={onConfirm}
          >
            {submittingTranscript ? 'Requesting...' : 'Request'}
          </CreditsButton>
        )}
      </div>
    </Dialog>
  );
};

export default RequestTranscript;
